var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('normal-input-item',{attrs:{"field":_vm.field,"isBaseUI":_vm.isBaseUI},on:{"update:field":function($event){_vm.field=$event},"click-button":_vm.clickButton,"field-change":_vm.fieldChange}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ecdee80","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/style-rem-loader??ref--1!./src/components/baseUI/kInput.vue
// module id = 1123
// module chunks = 2